module.exports = __webpack_public_path__ + "img/line-flow02.1fdeb63f.png";